import axios from 'axios'

export default  {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    find({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/brands/${id}`)
          .then((res) => {
            resolve(res.data.data.brand)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    create({commit}, brandForm) {
      return new Promise((resolve, reject) => {
        axios
          .post('/brands', brandForm)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    update({commit}, brandForm) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/brands/${brandForm.id}`, brandForm)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    delete({commit}, brandId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/brands/${brandId}`)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    restore({commit}, brandId) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/brands/${brandId}/restore`)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  getters: {},
}
